export default "__VITE_ASSET__BhBX0D2g__"